import api from 'api';

export const loadParentCampaigns = api('POST /api/parent-campaigns/grid');
export const createParentCampaign = api('POST /api/parent-campaigns');

export const editParentCampaign = api('PUT /api/parent-campaigns/:id');
export const loadParentCampaign = api('GET /api/parent-campaigns/:id');
export const loadParentCampaignDetails = api(
  'GET /api/parent-campaigns/:id/details'
);

export const exportParentCampaigns = api('POST /api/parent-campaigns/export', {
  responseType: 'blob',
});
